import React from "react";

import Image from "next/image";

import { Box, Container, Hidden, Typography } from "@mui/material";

import CollaboratorsImage from "../../../public/static/home/collaborations.svg";

const HomeCollaborations = (props) => (
  <Box
    sx={{
      backgroundColor: "background.paper",
      py: 4,
    }}
    {...props}
  >
    <Container
      maxWidth="lg"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        position: "relative",
      }}
    >
      <Image src={CollaboratorsImage} />
      <Hidden smUp>
        <Box
          sx={{
            left: 0,
            position: "absolute",
            px: 2,
            top: 0,
            width: "100%",
          }}
        >
          <Typography variant="h6" sx={{ pb: 2 }}>
            由2021年1月1至今，
          </Typography>
          <Typography variant="h6">飛天奶茶已與各個地區</Typography>
          <Typography
            variant="h6"
            display="inline-block"
            sx={{ verticalAlign: "middle" }}
          >
            超過
          </Typography>
          <Typography
            variant="h4"
            color="#ef5090"
            display="inline-block"
            sx={{ verticalAlign: "middle" }}
          >
            60
          </Typography>
          <Typography
            display="inline-block"
            variant="h6"
            sx={{ verticalAlign: "middle" }}
          >
            間企業/組織合作
          </Typography>
        </Box>
      </Hidden>
      <Hidden smDown>
        <Box
          sx={{
            left: 0,
            position: "absolute",
            px: { sm: 4, md: 2, lg: 0 },
            py: { sm: 4, lg: 8 },
            top: 0,
            width: "100%",
          }}
        >
          <Typography variant="h4">由2021年1月1至今，</Typography>
        </Box>
        <Box
          sx={{
            left: "40%",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%,-50%)",
          }}
        >
          <Typography variant="h4">飛天奶茶已與各個地區</Typography>
          <Typography
            variant="h3"
            display="inline-block"
            sx={{ verticalAlign: "middle" }}
          >
            超過
          </Typography>
          <Typography
            variant="h1"
            color="#ef5090"
            display="inline-block"
            sx={{ verticalAlign: "middle" }}
          >
            80
          </Typography>
          <Typography
            display="inline-block"
            variant="h3"
            sx={{ verticalAlign: "middle" }}
          >
            間企業/組織合作
          </Typography>
        </Box>
      </Hidden>
    </Container>
  </Box>
);

export default HomeCollaborations;
